import PropTypes from "prop-types";
// material-ui
import { useColorScheme, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// project imports
import { ThemeMode } from "config";

// assets
import { IconCaravan } from "@tabler/icons-react";

// ==============================|| LOGO SVG ||============================== //

export default function Logo({ dark = false, compact = false }) {
  const theme = useTheme();
  const { colorScheme } = useColorScheme();

  if (compact) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
        <Typography
          component="span"
          sx={{
            fontSize: "1.25rem",
            fontWeight: 700,
            color: theme.vars.palette.secondary.main,
            textDecoration: "none !important",
            "&:hover": { textDecoration: "none !important" },
            "&:focus": { textDecoration: "none !important" },
            "&:visited": { textDecoration: "none !important" },
          }}
        >
          BCC
        </Typography>
        <IconCaravan
          size={24}
          color={theme.vars.palette.secondary.main}
          style={{
            width: "24px",
            height: "24px",
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <IconCaravan
        size={48}
        color={theme.vars.palette.secondary.main}
        style={{
          width: "clamp(24px, 4vw, 48px)",
          height: "clamp(24px, 4vw, 48px)",
        }}
      />
      <Typography
        component="span"
        sx={{
          fontSize: { xs: "1.25rem", md: "2rem" },
          fontWeight: 700,
          color: theme.vars.palette.secondary.main,
          textDecoration: "none !important",
          "&:hover": { textDecoration: "none !important" },
          "&:focus": { textDecoration: "none !important" },
          "&:visited": { textDecoration: "none !important" },
        }}
      >
        BCC
      </Typography>
      <Typography
        component="span"
        sx={{
          fontSize: { xs: "1.25rem", md: "2rem" },
          fontWeight: 400,
          color: theme.vars.palette.text.primary,
          textDecoration: "none !important",
          "&:hover": { textDecoration: "none !important" },
          "&:focus": { textDecoration: "none !important" },
          "&:visited": { textDecoration: "none !important" },
        }}
      >
        Bookings
      </Typography>
    </Box>
  );
}

Logo.propTypes = {
  dark: PropTypes.bool,
  compact: PropTypes.bool,
};
